import styled from 'styled-components';
import { Link } from "react-router-dom";

export const Section = styled.div`
	height: 100%; 
	display: flex;
	flex-direction: column;
` 

export const OptionList = styled.div`
	padding : calc(100vw * (11 / 375)) calc(100vw * (17 / 375)) calc(100vw * (11 / 375)) calc(100vw * (17 / 375)); 
	border-bottom : ${({noborder})=>{return(noborder)?'none':'solid calc(100vw*(12/375)) #f7f7f7'}};
`

export const SectionHeader = styled.div`
	flex: 0 1 auto;
	width: 100%;
	height: calc(100vw * (51 / 375));
	min-height: calc(100vw * (51 / 375));
`;

 
export const SectionBody = styled.div`
	height: 100%;
	flex: 1 1 auto;
`
export const SectionClickItem = styled.span`
	display: block;
	font-weight: 500;
	font-size: calc(100vw * (14 / 375));
	line-height: calc(100vw * (17 / 375));
	color: #121212;
	padding : calc(100vw * (15 / 375)) 0;
	cursor: pointer;
`
export const SectionItem = styled(Link)`
	display: block;
	font-weight: 500;
	font-size: calc(100vw * (14 / 375));
	line-height: calc(100vw * (17 / 375));
	color: #121212;
	padding : calc(100vw * (15 / 375)) 0;
`
export const SectionExternalItem = styled.a`
	display: block;
	font-weight: 500;
	font-size: calc(100vw * (14 / 375));
	line-height: calc(100vw * (17 / 375));
	color: #121212;
	padding : calc(100vw * (15 / 375)) 0;
`
